<template>
    <div>
        <Navigation :inertia="inertia" :bg="bg" />
        <RouterView v-if="!inertia" />
        <slot v-else />
        <Footer />
        <Model />
    </div>
</template>
<script>
import Navigation from '@/layouts/Navigation.vue'
import Footer from '@/layouts/Footer.vue'
import Model from '@/components/Model.vue';
import { RouterView } from 'vue-router';
export default {
  props: {
    inertia: {
      type: Boolean,
      default: false
    },
    bg: {
      type: String,
      default: 'bg-nomad-light'
    }
  },
  components: {
    Navigation,
    Footer,
    Model,
    RouterView
  },
  created() {

  }

}
</script>